import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { COMMODITIES_FORM_DEFAULT_VALUES as DEFAULTS } from "web_myplann/Portfolio/Forms/CommoditiesForm/commoditiesFormDefaults";
import type { CommoditiesFormInput } from "web_myplann/Portfolio/Forms/CommoditiesForm/commoditiesFormSchema";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";

export const mapPortfolioToCommoditiesForm = (
	portfolio: PortfolioDetailResponseDTO,
): CommoditiesFormInput => {
	return {
		name: portfolio.name ?? DEFAULTS.name,
		producer: portfolio.producer ?? DEFAULTS.producer,
		product: portfolio.product ?? DEFAULTS.product,
		contractNumber: portfolio.contractNumber ?? DEFAULTS.contractNumber,
		productCategoryId:
			portfolio.productCategoryId ?? DEFAULTS.productCategoryId,
		signedAt: parseIsoDate(portfolio.signedAt),
		startAt: parseIsoDate(portfolio.startAt),
		endAt: parseIsoDate(portfolio.endAt),
	};
};
